import React from 'react';
import { pains } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function PainSection() {
  return <section aria-labelledby="pain-title" className="bg-teal-tint py-12 md:py-20" data-id="element-160" data-mp="38xetd8zbufpu">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-161" data-mp="2uxdq5mvlaw77">
        <SectionHeading id="pain-title" eyebrow={pains.eyebrow} title={pains.title} data-id="element-162" data-mp="2yzh4cj9n8ew6" />

        <ul className="mt-8 grid gap-3 sm:grid-cols-2 md:mt-12 md:gap-4" data-id="element-163" data-mp="2z1lf9l5yme5y">
          {pains.items.map(item => <li key={item.title} className="rounded-xl border border-teal-tintLine bg-white p-5 md:p-7" data-id="element-164" data-mp="2pysrhrvzkkkv">
              <span className="mb-3 block h-1 w-8 rounded-full bg-orange" aria-hidden="true" data-id="element-165" data-mp="2baog78z9jbc4" />
              <h3 className="font-display text-[17px] font-extrabold uppercase leading-snug tracking-tight text-teal md:text-[19px]" data-id="element-166" data-mp="2g8znpd2359r6">
                {item.title}
              </h3>
              <p className="mt-2 text-[16px] leading-relaxed text-ink/75" data-id="element-167" data-mp="278l36fwy3yoq">{item.text}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-[720px] text-center font-display text-[1.3rem] font-extrabold uppercase leading-tight tracking-tight text-orange-ink md:text-[1.75rem]" data-id="element-168" data-mp="3rm9a57btikwq">
          {pains.closing}
        </p>
      </div>
    </section>;
}